// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GothamBold";
  src: url("/fonts/gothambold_normal_normal.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
@font-face {
  font-family: "GothamNarrowBook";
  src: url("/fonts/GothamNarrowBook_normal_condensed.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
.cvx-font-gotham-bold {
  font-family: "GothamBold", Arial, sans-serif;
}

.cvx-fon-narrow-bold {
  font-family: "GothamNarrowBold", Arial, sans-serif;
}

.cvx-font-gotham-narrow-book {
  font-family: "GothamNarrowBook", Arial, sans-serif;
}

.cvx-gothan-medium {
  font-family: "GothamMedium", Arial, sans-serif;
}

/*font-szes*/
.extraLarge {
  font-size: 1.75rem;
  /*28px*/
}

.large2 {
  font-size: 1.375rem;
  /*22px*/
}

.large {
  font-size: 1.125rem;
  /*18px*/
}

.normal {
  font-size: 1rem;
  /*16px*/
}

.medium {
  font-size: 0.875rem;
  /*14px*/
}

.small {
  font-size: 0.75rem;
  /*12px*/
}

* {
  box-sizing: border-box;
}

body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

body.print-page,
html:has(body.print-page) {
  height: auto !important;
  overflow: auto !important;
}

body.print-page app-root {
  display: block !important;
  height: auto !important;
  overflow: visible !important;
}

html {
  font-size: 14px;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}
html body {
  min-height: 100%;
}

a:active {
  color: #009dd9;
}

app-root {
  display: grid;
  height: 100%;
  background-color: #ededee;
}

app-cvx-header {
  grid-area: header;
}

app-cvx-navbar {
  grid-area: nav;
}

app-cvx-main {
  grid-area: main;
}

app-cvx-aside-left {
  grid-area: aside-left;
}

app-cvx-footer {
  grid-area: footer;
  overflow: hidden !important;
}

.mat-accent.mat-mdc-checkbox {
  --mdc-checkbox-selected-pressed-icon-color: colors.\$medium-blue;
  --mdc-checkbox-selected-focus-icon-color: colors.\$medium-blue;
  --mdc-checkbox-selected-hover-icon-color: colors.\$medium-blue;
  --mdc-checkbox-selected-icon-color: colors.\$medium-blue;
  --mdc-checkbox-selected-focus-state-layer-color: colors.\$medium-blue;
  --mdc-checkbox-selected-hover-state-layer-color: colors.\$medium-blue;
  --mdc-checkbox-unselected-pressed-state-layer-color: colors.\$medium-blue;
}

.mat-accent.mat-mdc-radio-button {
  --mdc-radio-selected-focus-icon-color: colors.\$medium-blue;
  --mdc-radio-selected-hover-icon-color: colors.\$medium-blue;
  --mdc-radio-selected-icon-color: colors.\$medium-blue
  --mdc-radio-selected-pressed-icon-color: colors.\$medium-blue
  --mat-radio-checked-ripple-color: colors.\$medium-blue ;
}

.inventory-dialog-panel .mdc-dialog__surface {
  border-radius: 0 !important;
}
.inventory-dialog-panel .mat-mdc-dialog-content {
  max-height: calc(85vh - 120px);
  overflow: hidden;
}

.nextpage-tabs .mdc-tab__text-label {
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 18px;
  line-height: 22px;
  text-transform: none;
}
.nextpage-tabs .mdc-tab--active .mdc-tab__text-label,
.nextpage-tabs .mdc-tab:hover .mdc-tab__text-label {
  color: #0b2d71;
}
.nextpage-tabs {
  --mdc-tab-indicator-active-indicator-color: #0b2d71;
  --mdc-tab-indicator-active-indicator-height: 4px;
  --mat-tab-header-active-ripple-color: transparent;
  --mat-tab-header-inactive-ripple-color: transparent;
  --mat-tab-header-active-focus-indicator-color: #0b2d71;
}
.nextpage-tabs .mat-mdc-tab-header {
  border-bottom: none;
}
.nextpage-tabs .mat-mdc-tab-body-content {
  padding: 9px 0 0;
  overflow: visible;
}

@page {
  size: portrait;
  margin: 0.25in;
}
@media print {
  html,
  body {
    height: auto !important;
    overflow: visible !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  app-root {
    display: block !important;
    height: auto !important;
    overflow: visible !important;
  }
  .container.report {
    max-width: 100% !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .no-print {
    display: none !important;
  }
  .hiddenprint {
    display: none !important;
  }
  .dark-pale {
    background-color: #feffa4 !important;
  }
  * {
    font-size: 7pt;
  }
  h4, h5 {
    font-size: 1rem;
  }
}
app-root {
  overflow: hidden;
  grid-template-rows: 100px 46px 1fr 50px;
  grid-template-columns: 420px 1fr;
  grid-template-areas: "header header" "nav nav" "aside-left main" "footer footer";
}

app-cvx-main {
  overflow: auto;
}

app-cvx-aside-left {
  overflow: auto;
}

app-cvx-aside-right {
  overflow: auto;
}

app-cvx-footer {
  overflow: auto;
}

.contentPadding {
  display: inherit;
  flex-direction: inherit;
  flex-grow: inherit;
  width: 100%;
  padding: 40px;
}

.bg-white {
  background-color: #ffffff;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.content {
  flex-wrap: wrap;
  flex-basis: 0;
  flex-grow: 1;
  padding: 10px;
}

.access-loading {
  grid-area: main;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  background-color: #ededee;
}

.access-loading__spinner {
  width: 2.5rem;
  height: 2.5rem;
  border: 4px solid #dbdcdd;
  border-top-color: #0066b2;
  border-radius: 50%;
  animation: access-loading-spin 0.8s linear infinite;
}

@keyframes access-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .access-loading__spinner {
    animation-duration: 1.6s;
  }
}
.access-denied-nav {
  grid-area: nav;
  background-color: #0b2d71;
}

.access-denied-aside {
  grid-area: aside-left;
  background-color: #ffffff;
  border-right: 1px solid #dbdcdd;
}

.access-denied-main {
  grid-area: main;
  min-width: 0;
  overflow: auto;
  background-color: #ededee;
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/app/app.component.scss","webpack://./src/styles/global.scss","webpack://./src/styles/colors.scss","webpack://./src/styles/media-queries.scss","webpack://./src/styles/app.scss"],"names":[],"mappings":"AAQA;EACE,yBAAA;EACA,iEAAA;EACA,iBAPO;EAQP,gBARO;ACCT;ADUA;EACE,+BAAA;EACA,0EAAA;EACA,iBAdO;EAeP,gBAfO;ACOT;ADWA;EACE,4CAAA;ACTF;;ADYA;EACE,kDAAA;ACTF;;ADYA;EACE,kDAAA;ACTF;;ADYA;EACE,8CAAA;ACTF;;ADaA,YAAA;AACA;EACE,kBAxCW;EAyCX,OAAA;ACVF;;ADaA;EACE,mBA5CO;EA6CP,OAAA;ACVF;;ADaA;EACE,mBAhDM;EAiDN,OAAA;ACVF;;ADaA;EACE,eApDO;EAqDP,OAAA;ACVF;;ADaA;EACE,mBAxDO;EAyDP,OAAA;ACVF;;ADaA;EACE,kBA5DM;EA6DN,OAAA;ACVF;;ACtDA;EACI,sBAAA;ADyDJ;;ACtDA;;EAEI,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;ADyDJ;;ACpDA;;EAEI,uBAAA;EACA,yBAAA;ADuDJ;;ACpDA;EACI,yBAAA;EACA,uBAAA;EACA,4BAAA;ADuDJ;;ACpDA;EACI,eAAA;EACA,iDAAA;ADuDJ;ACrDI;EACI,gBAAA;ADuDR;;ACnDA;EACI,cCtCS;AF4Fb;;AC/CA;EACI,aAAA;EAEA,YAAA;EACA,yBCtBc;AFuElB;;AC9CA;EACI,iBAAA;ADiDJ;;AC7CA;EACI,cAAA;ADgDJ;;AC5CA;EACI,eAAA;AD+CJ;;AC3CA;EACI,qBAAA;AD8CJ;;ACzCA;EACI,iBAAA;EACA,2BAAA;AD4CJ;;ACHA;EACI,+DAAA;EACA,6DAAA;EACA,6DAAA;EACA,uDAAA;EACA,oEAAA;EACA,oEAAA;EACA,wEAAA;ADMJ;;ACCA;EACI,0DAAA;EACA,0DAAA;EACA;;wDAAA;ADIJ;;ACMI;EACI,2BAAA;ADHR;ACMI;EACI,8BAAA;EACA,gBAAA;ADJR;;ACcI;EACI,cCjKM;EDkKN,4CAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;ADXR;ACeI;;EAEI,cC5KI;AF+JZ;ACAA;EAiBI,mDAAA;EACA,gDAAA;EAGA,iDAAA;EACA,mDAAA;EACA,sDAAA;ADhBJ;ACmBI;EACI,mBAAA;ADjBR;ACqBA;EACQ,gBAAA;EACA,iBAAA;ADnBR;;AC4BA;EACE,cAAA;EAGA,cAAA;AD3BF;AC8BA;EACE;;IAEE,uBAAA;IACA,4BAAA;IACA,iCAAA;IACA,yBAAA;ED5BF;EC+BA;IACE,yBAAA;IACA,uBAAA;IACA,4BAAA;ED7BF;ECkCA;IACE,0BAAA;IACA,sBAAA;IACA,oBAAA;IACA,qBAAA;EDhCF;ECmCA;IACE,wBAAA;EDjCF;ECoCA;IACE,wBAAA;EDlCF;ECqCA;IACE,oCAAA;EDnCF;ECsCA;IACE,cAAA;EDpCF;ECuCA;IACE,eAAA;EDrCF;AACF;AG7IE;EACE,gBAAA;EACA,uCAAA;EACA,gCAAA;EACA,gFACE;AH8IN;;AGpIE;EACE,cAAA;AHuIJ;;AGpIE;EACE,cAAA;AHuIJ;;AGpIE;EACE,cAAA;AHuIJ;;AGpIE;EACE,cAAA;AHuIJ;;AIzOA;EACI,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AJ4OJ;;AIzOA;EACI,yBFiBI;AF2NR;;AIzOA;EACI,8DAAA;AJ4OJ;;AIzOA;EACI,eAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;AJ4OJ;;AA/PA;EACC,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yBEoBiB;AF8OlB;;AA/PA;EACC,aAAA;EACA,cAAA;EACA,yBAAA;EACA,yBEfa;EFgBb,kBAAA;EACA,mDAAA;AAkQD;;AA/PA;EACC;IACC,yBAAA;EAkQA;AACF;AA/PA;EACC;IACC,wBAAA;EAiQA;AACF;AA9PA;EACC,cAAA;EACA,yBEnCW;AFmSZ;;AA7PA;EACC,qBAAA;EACA,yBEZO;EFaP,+BAAA;AAgQD;;AA7PA;EACC,eAAA;EACA,YAAA;EACA,cAAA;EACA,yBEnBiB;AFmRlB","sourcesContent":["// FONTS\n$extraLarge: 1.75rem; // 28pt\n$large2: 1.375rem; // 22pt\n$large: 1.125rem; // 18pt\n$normal: 1rem; // 16pt\n$medium: 0.875rem; // 14pt\n$small: 0.75rem; // 12pt\n\n@font-face {\n  font-family: \"GothamBold\";\n  src: url(\"/fonts/gothambold_normal_normal.woff2\") format(\"woff2\");\n  font-weight: $normal;\n  font-style: $normal;\n}\n\n@font-face {\n  font-family: \"GothamNarrowBook\";\n  src: url(\"/fonts/GothamNarrowBook_normal_condensed.woff2\") format(\"woff2\");\n  font-weight: $normal;\n  font-style: $normal;\n}\n\n.cvx-font-gotham-bold {\n  font-family: \"GothamBold\", Arial, sans-serif;\n}\n\n.cvx-fon-narrow-bold {\n  font-family: \"GothamNarrowBold\", Arial, sans-serif;\n}\n\n.cvx-font-gotham-narrow-book {\n  font-family: \"GothamNarrowBook\", Arial, sans-serif;\n}\n\n.cvx-gothan-medium {\n  font-family: \"GothamMedium\", Arial, sans-serif;\n}\n\n\n/*font-szes*/\n.extraLarge {\n  font-size: $extraLarge;\n  /*28px*/\n}\n\n.large2 {\n  font-size: $large2;\n  /*22px*/\n}\n\n.large {\n  font-size: $large;\n  /*18px*/\n}\n\n.normal {\n  font-size: $normal;\n  /*16px*/\n}\n\n.medium {\n  font-size: $medium;\n  /*14px*/\n}\n\n.small {\n  font-size: $small;\n  /*12px*/\n}","@use '../styles/main.scss' as *;\n@use '../styles/colors.scss' as colors;\n\n.access-loading {\n\tgrid-area: main;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmin-width: 0;\n\tbackground-color: colors.$background-gray;\n}\n\n.access-loading__spinner {\n\twidth: 2.5rem;\n\theight: 2.5rem;\n\tborder: 4px solid colors.$light-gray;\n\tborder-top-color: colors.$medium-blue;\n\tborder-radius: 50%;\n\tanimation: access-loading-spin 0.8s linear infinite;\n}\n\n@keyframes access-loading-spin {\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n@media (prefers-reduced-motion: reduce) {\n\t.access-loading__spinner {\n\t\tanimation-duration: 1.6s;\n\t}\n}\n\n.access-denied-nav {\n\tgrid-area: nav;\n\tbackground-color: colors.$dark-blue;\n}\n\n.access-denied-aside {\n\tgrid-area: aside-left;\n\tbackground-color: colors.$white;\n\tborder-right: 1px solid colors.$light-gray;\n}\n\n.access-denied-main {\n\tgrid-area: main;\n\tmin-width: 0;\n\toverflow: auto;\n\tbackground-color: colors.$background-gray;\n}","@use 'fonts' as *;\n@use 'colors' as colors;\n\n* {\n    box-sizing: border-box;\n}\n\nbody,\nhtml {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n}\n\n// Standalone worksheet print page — bypass the app shell and allow the\n// long worksheet to scroll on screen (overrides the global overflow:hidden).\nbody.print-page,\nhtml:has(body.print-page) {\n    height: auto !important;\n    overflow: auto !important;\n}\n\nbody.print-page app-root {\n    display: block !important;\n    height: auto !important;\n    overflow: visible !important;\n}\n\nhtml {\n    font-size: 14px;\n    font-family: Roboto, 'Helvetica Neue', sans-serif;\n\n    body {\n        min-height: 100%;\n    }\n}\n\na:active {\n    color: colors.$light-blue;\n}\n\n// -----------------------------------------------------------------------------------\n// LAYOUT ----------------------------------------------------------------------------\n// -----------------------------------------------------------------------------------\n\napp-root {\n    display: grid;\n    //grid-template-columns: 100%;\n    height: 100%;\n    background-color: colors.$background-gray;\n}\n\napp-cvx-header {\n    grid-area: header;\n    //background-color: aqua;\n}\n\napp-cvx-navbar {\n    grid-area: nav;\n    //background-color: rgb(57, 44, 245);\n}\n\napp-cvx-main {\n    grid-area: main;\n    //background-color: rgb(192, 196, 196);\n}\n\napp-cvx-aside-left {\n    grid-area: aside-left;\n    //background-color: rgb(233, 22, 252);\n}\n\n\napp-cvx-footer {\n    grid-area: footer;\n    overflow: hidden !important;\n    //background-color: rgb(247, 54, 54);\n}\n\n// -----------------------------------------------------------------------------------\n// -----------------------------------------------------------------------------------\n// -----------------------------------------------------------------------------------\n\n// -----------------------------------------------------------------------------------\n// --BUTTONS--------------------------------------------------------------------------\n// -----------------------------------------------------------------------------------\n// button[mat-flat-button].cvx-button-primary {\n//     @extend .cvx-font-gotham-bold;\n//     background-color: colors.$medium-blue;\n//     border-radius: 7px;\n//     font-size: 1em;\n// }\n\n// button[mat-flat-button].cvx-button-primary:hover {\n//     background-color: colors.$dark-blue;\n// }\n\n//DISABLED\n// button[mat-flat-button][disabled] {\n//     @extend .cvx-font-gotham-bold;\n//     background-color: colors.$light-gray;\n//     color: colors.$medium-gray;\n//     border-radius: 7px;\n//     font-size: 1em;\n//     pointer-events: none;\n//     cursor: default;\n// }\n\n// -----------------------------------------------------------------------------------\n// --SELECT (DROPDOWNS)---------------------------------------------------------------\n// -----------------------------------------------------------------------------------\n\n// -----------------------------------------------------------------------------------\n// --CHECKBOX---------------------------------------------------------------------------------\n// -----------------------------------------------------------------------------------\n\n.mat-accent.mat-mdc-checkbox {\n    --mdc-checkbox-selected-pressed-icon-color: colors.$medium-blue;\n    --mdc-checkbox-selected-focus-icon-color: colors.$medium-blue;\n    --mdc-checkbox-selected-hover-icon-color: colors.$medium-blue;\n    --mdc-checkbox-selected-icon-color: colors.$medium-blue;\n    --mdc-checkbox-selected-focus-state-layer-color: colors.$medium-blue;\n    --mdc-checkbox-selected-hover-state-layer-color: colors.$medium-blue;\n    --mdc-checkbox-unselected-pressed-state-layer-color: colors.$medium-blue;\n}\n\n// -----------------------------------------------------------------------------------\n// --RADIOBUTTON----------------------------------------------------------------------\n// -----------------------------------------------------------------------------------\n\n.mat-accent.mat-mdc-radio-button {\n    --mdc-radio-selected-focus-icon-color: colors.$medium-blue;\n    --mdc-radio-selected-hover-icon-color: colors.$medium-blue;\n    --mdc-radio-selected-icon-color: colors.$medium-blue\n    --mdc-radio-selected-pressed-icon-color: colors.$medium-blue\n    --mat-radio-checked-ripple-color: colors.$medium-blue\n}\n\n// -----------------------------------------------------------------------------------\n// --INVENTORY DIALOG-----------------------------------------------------------------\n// -----------------------------------------------------------------------------------\n\n.inventory-dialog-panel {\n    .mdc-dialog__surface {\n        border-radius: 0 !important;\n    }\n\n    .mat-mdc-dialog-content {\n        max-height: calc(85vh - 120px);\n        overflow: hidden;\n    }\n}\n\n// -----------------------------------------------------------------------------------\n// --NEXTPAGE TABS (mat-tab-group styled to match NextPage tab component)-------------\n// -----------------------------------------------------------------------------------\n\n.nextpage-tabs {\n    // Tab label text: NextPage medium-blue, GothamBold 18px\n    .mdc-tab__text-label {\n        color: colors.$medium-blue;\n        font-family: 'GothamBold', Arial, sans-serif;\n        font-size: 18px;\n        line-height: 22px;\n        text-transform: none;\n    }\n\n    // Active and hovered label: NextPage dark-blue\n    .mdc-tab--active .mdc-tab__text-label,\n    .mdc-tab:hover .mdc-tab__text-label {\n        color: colors.$dark-blue;\n    }\n\n    // Ink bar (active underline): NextPage dark-blue, 4px thick\n    --mdc-tab-indicator-active-indicator-color: #{colors.$dark-blue};\n    --mdc-tab-indicator-active-indicator-height: 4px;\n\n    // Remove default Material ripple / focus ring tint\n    --mat-tab-header-active-ripple-color: transparent;\n    --mat-tab-header-inactive-ripple-color: transparent;\n    --mat-tab-header-active-focus-indicator-color: #{colors.$dark-blue};\n\n    // Suppress bottom divider line that Material adds below the tab bar\n    .mat-mdc-tab-header {\n        border-bottom: none;\n    }\n\n    // Tab panel: no extra padding so .content wrappers sit flush\n.mat-mdc-tab-body-content {\n        padding: 9px 0 0;\n        overflow: visible;\n    }\n}\n\n// ------------------------------------------------------------------\n// Print styles for the standalone worksheet page.\n// The page already renders without the app shell, so no visibility\n// isolation is needed — just ensure the content lays out for print.\n// ------------------------------------------------------------------\n@page {\n  size: portrait;\n  // Small margins so the fixed-width (730px ≈ 7.6in) worksheet tables\n  // fit within the printable page width instead of being clipped.\n  margin: 0.25in;\n}\n\n@media print {\n  html,\n  body {\n    height: auto !important;\n    overflow: visible !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  app-root {\n    display: block !important;\n    height: auto !important;\n    overflow: visible !important;\n  }\n\n  // Let the report span the full printable width so the wide layout\n  // tables are not pushed outside the page and clipped from view.\n  .container.report {\n    max-width: 100% !important;\n    width: 100% !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  .no-print {\n    display: none !important;\n  }\n\n  .hiddenprint {\n    display: none !important;\n  }\n\n  .dark-pale {\n    background-color: #feffa4 !important;\n  }\n\n  * {\n    font-size: 7pt;\n  }\n\n  h4, h5 {\n    font-size: 1rem;\n  }\n}\n\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;","// RESPOSNIVE LAYOUT\n\n// // SMALL SMARTPHONES (320PX - 480PX)\n// // MEDIUM SMARTPHONES (481PX - 767PX)\n// // LARGE SMARTPHONES (768PX - 991PX)\n// @media screen and (min-width: 320px) and (max-width: 480px),\n//   screen and (min-width: 481px) and (max-width: 767px),\n//   screen and (min-width: 768px) and (max-width: 991px) {\n//   app-root {\n//     grid-template-rows: 40px 20px 50px 1fr 50px 20px;\n//     grid-template-areas:\n//       \"header\"\n//       \"nav\"\n//       \"aside-left\"\n//       \"main\"\n//       \"aside-right\"\n//       \"footer\";\n//   }\n\n//   app-cvx-main {\n//     overflow: auto;\n//   }\n\n//   app-cvx-aside-left {\n//     overflow: hidden;\n//   }\n\n//   app-cvx-aside-right {\n//     overflow: hidden;\n//   }\n\n//   app-cvx-footer {\n//     overflow: hidden;\n//   }\n// }\n\n// // SMALL TABLETS (600PX - 768PX)\n// // LARGE TABLETS (769PX - 1024PX)\n// @media screen and (min-width: 600px) and (max-width: 768px),\n//   screen and (min-width: 769px) and (max-width: 1024px) {\n//   app-root {\n//     grid-template-rows: 80px 1fr 50px;\n//     grid-template-columns: 200px 1fr 200px;\n//     grid-template-areas:\n//       \"header nav nav\"\n//       \"aside-left main aside-right\"\n//       \"footer footer footer\";\n//   }\n\n//   app-cvx-main {\n//     overflow: auto;\n//   }\n\n//   app-cvx-aside-left {\n//     overflow: auto;\n//   }\n\n//   app-cvx-aside-right {\n//     overflow: auto;\n//   }\n\n//   app-cvx-footer {\n//     overflow: hidden;\n//   }\n// }\n\n// // SMALL DESKTOPS AND LAPTOPS (1024PX - 1280PX)\n// // MEDIUM DESKTOPS AND LAPTOPS (1281PX - 1440PX)\n// // LARGE DESKTOPS AND LAPTOPS (1441PX - 1920PX AND ABOVE)\n// @media screen and (min-width: 1024px) and (max-width: 1280px),\n//   screen and (min-width: 1281px) and (max-width: 1440px),\n//   screen and (min-width: 1441px) {\n  app-root {\n    overflow: hidden;\n    grid-template-rows: 100px 46px 1fr 50px;\n    grid-template-columns: 420px 1fr;\n    grid-template-areas:\n      \"header header\"\n      \"nav nav\"\n      \"aside-left main\" //aside-left main aside-right\n      \"footer footer\";\n    // \"header header header\"\n    // \"nav nav nav\"\n    // \"aside-left main main\" //aside-left main aside-right\n    // \"footer footer footer\";\n  }\n\n  app-cvx-main {\n    overflow: auto;\n  }\n\n  app-cvx-aside-left {\n    overflow: auto;\n  }\n\n  app-cvx-aside-right {\n    overflow: auto;\n  }\n\n  app-cvx-footer {\n    overflow: auto;\n  }\n","@use 'colors' as colors;\n\n.contentPadding {\n    display: inherit;\n    flex-direction: inherit;\n    flex-grow: inherit;\n    width: 100%;\n    padding: 40px;\n}\n\n.bg-white {\n    background-color:colors.$white;\n}\n\n.shadow-sm {\n    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;\n}\n\n.content {\n    flex-wrap: wrap;\n    flex-basis: 0;\n    flex-grow: 1;\n    padding: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
